import { USER_IS_A_MEMBER_COOKIE, LONG_TIME_COOKIE_EXPIRATION } from '../../constants/consts';

export default {
	methods: {
		getMembershipCookie() {
			return this.$cookie.get(USER_IS_A_MEMBER_COOKIE);
		},
		setMembershipCookie() {
			this.$cookie.set(USER_IS_A_MEMBER_COOKIE, true, { expires: LONG_TIME_COOKIE_EXPIRATION });
		}
	}
};
